import React from 'react'
import '../assets/css/Footer.css'
function Footer() {
  return (
    <div className='footer-sec'>
      <hr />
      <h1 className='footer-title'>FinTrec</h1>
      <p className='footer-para'>Copyright © 2024, All Rights Reserved</p><br/>
      <p className='footer-para2'>ContactUs: <span className='footer-contact'>ankitanandfullstackdeveloper@gmail.com</span></p>
    </div>
  )
}

export default Footer
